<template>
    <div class="operations-tree ml-5 mt-3">
        <div class="d-flex">
            <button type="button" class="btn btn-sm btn-back" :class="{invisible: !hasChilds}" @click="toggleChildrens">
                <i class="fa fa-angle-right px-1" v-if="childrensHidden"></i>
                <i class="fa fa-angle-down px-1" v-else></i>
            </button>
            <div class="operations-tree-name px-4 d-flex ml-2 d-flex justify-content-between align-items-center" :class="{'is-root': isRoot}">
              <span v-if="!isEditName">{{operations.name}}</span>
              <input v-else type="text" class="form-control form-control-sm" v-model="editName" />
              <template v-if="!isRoot && isInEdit">
                  <i v-if="!isEditName" @click="editOperationName" class="fa fa-pencil pl-3 cursor-pointer"></i>
                  <template v-else>
                    <i class="fa fa-times pl-3 cursor-pointer" @click="()=>isEditName = false"></i>
                    <i class="fa fa-check pl-3 cursor-pointer" @click="saveNewOperationName"></i>
                  </template>
              </template>
            </div>
            <button class="btn btn-sm btn-primary d-flex ml-2" @click="goToTable" v-if="!hasChilds && isInEdit"><i class="fa fa-table"></i></button>
            <button class="btn btn-sm btn-primary d-flex ml-2" @click="addChild" v-if="isShowAddChild">+</button>
            <button class="btn btn-sm btn-outline-primary ml-2" @click="deleteOperation" v-if="!isRoot && isInEdit"><i class="ico ico-delete"></i></button>
        </div>
        <div class="form-inline mt-1" v-if="isAddChild && isInEdit">
            <input type="text" class="form-control" v-focus @keypress.enter.prevent="saveNewChild" v-if="isAddChild" v-model="addChildName">
            <button type="button" class="btn btn-sm btn-secondary px-3" @click="cancelAddChild"><i class="fa fa-times"></i></button>
            <button type="button" class="btn btn-sm btn-primary px-3" @click="saveNewChild"><i class="fa fa-check"></i></button>
        </div>
        <div class="d-block" v-for="(child, index) in operations.children" :key="child.id">
          <template v-if="!childrensHidden">
            <OperationsTree v-if="hasChilds" :operations="child" :isInEdit="isInEdit" :printMachineId="printMachineId" />
            <div class="d-block ml-5" v-if="index == operations.children.length - 1">
                <button class="btn btn-sm btn-outline-primary mt-1" @click="addNewOperation" v-if="!isAddNewOperation && isInEdit">+</button>
                <div class="form-inline mt-1" v-if="isAddNewOperation && isInEdit">
                    <input type="text" class="form-control" v-focus @keypress.enter.prevent="saveNewOperation" v-if="isAddNewOperation" v-model="newOperationName">
                    <button type="button" class="btn btn-sm btn-secondary px-3" @click="cancelAddNewOperation"><i class="fa fa-times"></i></button>
                    <button type="button" class="btn btn-sm btn-primary px-3" @click="saveNewOperation"><i class="fa fa-check"></i></button>
                </div>
            </div>
          </template>
        </div>
    </div>
</template>

<script>
export default {
  name: 'OperationsTree',
  props: {
    isInEdit: {
      default: false
    },
    operations: {
      default: null
    },
    printMachineId: {
      default: null
    }
  },
  directives: {
    focus: {
      // directive definition
      inserted: function (el) {
        el.focus()
      }
    }
  },
  data: function () {
    return {
      childrensHidden: false,
      isAddNewOperation: false,
      isAddChild: false,
      addChildName: null,
      newOperationName: null,
      isEditName: false,
      editName: ''
    }
  },
  methods: {
    addNewOperation () {
      this.isAddNewOperation = true
    },
    addChild () {
      this.isAddChild = true
    },
    deleteOperation () {
      this.$modal.show('dialog', {
        title: 'Внимание!',
        text: 'Вы уверены что хотите удалить?',
        buttons: [
          {
            title: 'Нет'
          },
          {
            title: 'Да',
            default: true,
            handler: () => {
              this.$eventBus.$emit('deleteOperation', this.operations.id)
              this.$modal.hide('dialog')
            }
          }
        ]
      })
    },
    toggleChildrens () {
      this.childrensHidden = !this.childrensHidden
    },
    cancelAddNewOperation () {
      this.isAddNewOperation = false
      this.newOperationName = null
    },
    saveNewOperation () {
      const newOperation = {
        name: this.newOperationName,
        parent: this.operations.id
      }
      this.$eventBus.$emit('addNewOperationEvent', newOperation)
      this.cancelAddNewOperation()
    },
    cancelAddChild () {
      this.isAddChild = false
      this.addChildName = null
    },
    editOperationName () {
      this.editName = this.operations.name
      this.isEditName = true
    },
    saveNewOperationName () {
      this.$eventBus.$emit('saveNewOperationNameEvent', { id: this.operations.id, name: this.editName })
      this.isEditName = false
    },
    saveNewChild () {
      const newOperation = {
        name: this.addChildName,
        parent: this.operations.id
      }
      this.$eventBus.$emit('addNewOperationEvent', newOperation)
      this.cancelAddChild()
    },
    goToTable () {
      this.$router.push(
        `/settings/print-machine/${this.printMachineId}/operation-table/${
          this.operations.id
        }`
      )
    }
  },
  computed: {
    isRoot () {
      return !this.operations.parent
    },
    hasChilds () {
      return !!this.operations.children
    },
    isShowAddChild () {
      return !this.hasChilds && this.isInEdit && !this.operations.preset
    }
  }
}
</script>

<style lang="scss">
.operations-tree-name {
  display: inline-block;
  color: #28bd8b;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  text-transform: uppercase;
  font-weight: 700;
  line-height: 42px;
  border-radius: 21px;
  box-shadow: inset 0 1px 0 rgba(40, 189, 139, 0.15);
  background-color: #e9f8f3;
  max-width: 400px;
  box-sizing: border-box;

  span {
    max-width: 350px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &.is-root {
    background-color: #28bd8b;
    color: #fff;
  }
}
</style>
